import type { ConfiguratorPageDefinition } from "~/features/configurator/ConfiguratorPageDefinition";

let definitions: readonly ConfiguratorPageDefinition[] = [];
let definitionsByProductCode = new Map<string, ConfiguratorPageDefinition>();

/**
 * Supply the configurator definitions from an application composition root.
 *
 * Keeping this lookup independent from the concrete configurator pages lets
 * reducers, selectors, and shared configurator code depend on the registry
 * without pulling those pages back into their own dependency graph.
 */
export function initializeConfiguratorRegistry(nextDefinitions: readonly ConfiguratorPageDefinition[]): void {
  const nextDefinitionsByProductCode = new Map<string, ConfiguratorPageDefinition>();

  for (const definition of nextDefinitions) {
    if (nextDefinitionsByProductCode.has(definition.productCode)) {
      throw new Error(`Duplicate configurator definition registered for productCode: ${definition.productCode}`);
    }
    nextDefinitionsByProductCode.set(definition.productCode, definition);
  }

  definitions = [...nextDefinitions];
  definitionsByProductCode = nextDefinitionsByProductCode;
}

export function getConfiguratorDefinition(productCode: string): ConfiguratorPageDefinition {
  const definition = definitionsByProductCode.get(productCode);
  if (!definition) {
    throw new Error(`No configurator definition registered for productCode: ${productCode}`);
  }
  return definition;
}

export function getAllConfiguratorDefinitions(): readonly ConfiguratorPageDefinition[] {
  return definitions;
}
